/* @flow */
import React from 'react';

import TBody from 'components/UIKit/Table/TBody';
import CasesRow from './CasesRow';

type CasesRowsProps = {
  children: any,
  router: Object
}

export default function CasesRows({
  children, router
}: CasesRowsProps): React.Element {
  return (
    TBody({
      children: children.map(cas => (
        <CasesRow key={cas.id} router={router}>{cas}</CasesRow>
      ))
    })
  );
}
